import { Attachements } from "../new-rep-application-interfaces/attachements.interface";
import { Checklist } from "../new-rep-application-interfaces/checklist.interface";
import { EmploymentHistory } from "../new-rep-application-interfaces/employmenthistory.interface";
import { academicQualifications, Qualifications } from "../new-rep-application-interfaces/qualifications.interface";

export class NewRepApplication {
    private id!: number;
    private fullNameNric!: string;
    private preferredName!: string;
    private branch!: string;
    private finacialServiceDir!: string;
    private finacialServiceMan!: string;
    private personalEmailAddres!: string;
    private nricNo!: string;
    private dateOfBirth!: string;
    private gender!: string;
    private nationality!: string;
    private placeOfBirth!: string;
    private finPassportNo!: string;
    private Race!: string;
    private maritalStatus!: string;
    private spouseNameNric!: string;
    private spouseNricNo!: string;
    private spouseDob!: string;
    private spouseNationality!: string;
    private spouseOccuption!: string;
    private spouseNameoftheemployer!: string;
    private spouseFinPassportNo!: string;
    private address!: string;
    private homeNumber!: string;
    private mobileNumber!: string;
    private personalEmailAddress!: string;
    private bankname!: string;
    private bankBranchName!: string;
    private bankAccountNumber!: string;
    private serviceStatusNotApplicable!: boolean;
    private serviceStatus!: string;
    private enlistmentDate!: string;
    private ordDate!: string;
    private bscGrade!: string;
    private bscSatisfactory!: string;
    private bscGrade_1!: string;
    private bscSatisfactory_1!: string;
    private m5_res5!: string;
    private m9!: string;
    private m8_rep!: string;
    private bcp!: string;
    private m6_rep!: string;
    private m9a!: string;
    private m8a_rep!: string;
    private pgi!: string;
    private m6a_rep!: string;
    private cm_lip!: string;
    private cm_cis!: string;
    private commgi!: string;
    private cm_cmp!: string;
    private hi!: string;
    private cm_lic!: string;
    private cert_in_gi!: string;
    private employment_history!: EmploymentHistory[];
    private qualifications!: Qualifications[];
    private academicQualifications!: academicQualifications[];
    private checklist!: Checklist[];
    private attachments!: Attachements[];
    private comment!: string;
    private isAgreed!: boolean;
    private fullName!: string;
    private date!: string;

    constructor() { }

    // Getters & Setters

    getId(): number {
        return this.id;
    }
    setId(id: number) {
        this.id = id;
    }

    getFullNameNric(): string {
        return this.fullNameNric;
    }

    setFullNameNric(fullNameNric: string) {
        this.fullNameNric = fullNameNric;
    }

    getPreferredName(): string {
        return this.preferredName;
    }

    setPreferredName(preferredName: string) {
        this.preferredName = preferredName;
    }

    getBranch(): string {
        return this.branch;
    }

    setBranch(branch: string) {
        this.branch = branch;
    }

    getFinacialServiceDir(): string {
        return this.finacialServiceDir;
    }

    setFinacialServiceDir(finacialServiceDir: string) {
        this.finacialServiceDir = finacialServiceDir;
    }

    getFinacialServiceMan(): string {
        return this.finacialServiceMan;
    }

    setFinacialServiceMan(finacialServiceMan: string) {
        this.finacialServiceMan = finacialServiceMan;
    }

    getPersonalEmailAddres(): string {
        return this.personalEmailAddres;
    }

    setPersonalEmailAddres(personalEmailAddres: string) {
        this.personalEmailAddres = personalEmailAddres;
    }

    getNricNo(): string {
        return this.nricNo;
    }

    setNricNo(nricNo: string) {
        this.nricNo = nricNo;
    }

    getDateOfBirth(): string {
        return this.dateOfBirth;
    }

    setDateOfBirth(dateOfBirth: string) {
        this.dateOfBirth = dateOfBirth;
    }

    getGender(): string {
        return this.gender;
    }

    setGender(gender: string) {
        this.gender = gender;
    }

    getNationality(): string {
        return this.nationality;
    }

    setNationality(nationality: string) {
        this.nationality = nationality;
    }

    getPlaceOfBirth(): string {
        return this.placeOfBirth;
    }

    setPlaceOfBirth(placeOfBirth: string) {
        this.placeOfBirth = placeOfBirth;
    }

    getFinPassportNo(): string {
        return this.finPassportNo;
    }

    setFinPassportNo(finPassportNo: string) {
        this.finPassportNo = finPassportNo;
    }

    getRace(): string {
        return this.Race;
    }

    setRace(Race: string) {
        this.Race = Race;
    }

    getMaritalStatus(): string {
        return this.maritalStatus;
    }

    setMaritalStatus(maritalStatus: string) {
        this.maritalStatus = maritalStatus;
    }

    getSpouseNameNric(): string {
        return this.spouseNameNric;
    }

    setSpouseNameNric(spouseNameNric: string) {
        this.spouseNameNric = spouseNameNric;
    }

    getSpouseNricNo(): string {
        return this.spouseNricNo;
    }

    setSpouseNricNo(spouseNricNo: string) {
        this.spouseNricNo = spouseNricNo;
    }


    getSpouseNationality(): string {
        return this.spouseNationality;
    }

    setSpouseNationality(spouseNationality: string) {
        this.spouseNationality = spouseNationality;
    }

    getSpouseOccuption(): string {
        return this.spouseOccuption;
    }

    setSpouseOccuption(spouseOccuption: string) {
        this.spouseOccuption = spouseOccuption;
    }

    getSpouseNameoftheemployer(): string {
        return this.spouseNameoftheemployer;
    }

    setSpouseNameoftheemployer(spouseNameoftheemployer: string) {
        this.spouseNameoftheemployer = spouseNameoftheemployer;
    }

    getSpouseDob(): string {
        return this.spouseDob;
    }

    setSpouseDob(spouseDob: string) {
        this.spouseDob = spouseDob;
    }


    getSpouseFinPassportNo(): string {
        return this.spouseFinPassportNo;
    }

    setSpouseFinPassportNo(spouseFinPassportNo: string) {
        this.spouseFinPassportNo = spouseFinPassportNo;
    }


    getAddress(): string {
        return this.address;
    }

    setAddress(address: string) {
        this.address = address;
    }

    getMobileNumber(): string {
        return this.mobileNumber;
    }

    setMobileNumber(mobileNumber: string) {
        this.mobileNumber = mobileNumber;
    }


    getHomeNumber(): string {
        return this.homeNumber;
    }

    setHomeNumber(homeNumber: string) {
        this.homeNumber = homeNumber;
    }


    getPersonalEmailAddress(): string {
        return this.personalEmailAddress;
    }

    setPersonalEmailAddress(personalEmailAddress: string) {
        this.personalEmailAddress = personalEmailAddress;
    }

    getBankname(): string {
        return this.bankname;
    }

    setBankname(bankname: string) {
        this.bankname = bankname;
    }

    getBankBranchName(): string {
        return this.bankBranchName;
    }

    setBankBranchName(bankBranchName: string) {
        this.bankBranchName = bankBranchName;
    }

    getBankAccountNumber(): string {
        return this.bankAccountNumber;
    }

    setBankAccountNumber(bankAccountNumber: string) {
        this.bankAccountNumber = bankAccountNumber;
    }

    getServiceStatusNotApplicable(): boolean {
        return this.serviceStatusNotApplicable;
    }

    setServiceStatusNotApplicable(serviceStatusNotApplicable: boolean) {
        this.serviceStatusNotApplicable = serviceStatusNotApplicable;
    }
    getServiceStatus(): string {
        return this.serviceStatus;
    }

    setServiceStatus(serviceStatus: string) {
        this.serviceStatus = serviceStatus;
    }

    getEnlistmentDate(): string {
        return this.enlistmentDate;
    }

    setEnlistmentDate(enlistmentDate: string) {
        this.enlistmentDate = enlistmentDate;
    }

    getOrdDate(): string {
        return this.ordDate;
    }

    setOrdDate(ordDate: string) {
        this.ordDate = ordDate;
    }

    getBscGrade(): string {
        return this.bscGrade;
    }

    setBscGrade(bscGrade: string) {
        this.bscGrade = bscGrade;
    }

    getBscSatisfactory(): string {
        return this.bscSatisfactory;
    }

    setBscSatisfactory(bscSatisfactory: string) {
        this.bscSatisfactory = bscSatisfactory;
    }
    getBscGrade_1(): string {
        return this.bscGrade_1;
    }

    setm5_res5(m5_res5: string) {
        this.m5_res5 = m5_res5;
    }

    getm5_res5(): string {
        return this.m5_res5;
    }

    setm6_rep(m6_rep: string) {
        this.m6_rep = m6_rep;
    }

    getm6_rep(): string {
        return this.m6_rep;
    }
    setm9(m9: string) {
        this.m9 = m9;
    }

    getm9(): string {
        return this.m9;
    }

    getm8_rep(): string {
        return this.m8_rep;
    }
    setm8_rep(m8_rep: string) {
        this.m8_rep = m8_rep;
    }

    getm9a(): string {
        return this.m9a;
    }
    setm9a(m9a: string) {
        this.m9a = m9a;
    }

    gethi(): string {
        return this.hi;
    }
    sethi(hi: string) {
        this.hi = hi;
    }

    getcert_in_gi(): string {
        return this.cert_in_gi;
    }
    setcert_in_gi(cert_in_gi: string) {
        this.cert_in_gi = cert_in_gi;
    }

    getbcp(): string {
        return this.bcp;
    }
    setcbcp(bcp: string) {
        this.bcp = bcp;
    }

    getm8a_rep(): string {
        return this.m8a_rep;
    }
    setm8a_rep(m8a_rep: string) {
        this.m8a_rep = m8a_rep;
    }

    getcm_cis(): string {
        return this.cm_cis;
    }
    setcm_cis(cm_cis: string) {
        this.cm_cis = cm_cis;
    }

    getcm_cmp(): string {
        return this.cm_cmp;
    }
    setcm_cmp(cm_cmp: string) {
        this.cm_cmp = cm_cmp;
    }

    getpgi(): string {
        return this.pgi;
    }
    setpgi(pgi: string) {
        this.pgi = pgi;
    }

    getcm_lip(): string {
        return this.cm_lip;
    }
    setcm_lip(cm_lip: string) {
        this.cm_lip = cm_lip;
    }

    getm6a_rep(): string {
        return this.m6a_rep;
    }
    setm6a_rep(m6a_rep: string) {
        this.m6a_rep = m6a_rep;
    }

    getcm_lic(): string {
        return this.cm_lic;
    }
    setcm_lic(cm_lic: string) {
        this.cm_lic = cm_lic;
    }

    getcommgi(): string {
        return this.commgi;
    }
    setcommgi(commgi: string) {
        this.commgi = commgi;
    }

    setBscGrade_1(bscGrade_1: string) {
        this.bscGrade_1 = bscGrade_1;
    }

    getBscSatisfactory_1(): string {
        return this.bscSatisfactory_1;
    }

    setBscSatisfactory_1(bscSatisfactory_1: string) {
        this.bscSatisfactory_1 = bscSatisfactory_1;
    }

    getComment(): string {
        return this.comment;
    }

    setComment(comment: string) {
        this.comment = comment;
    }

    getFullName(): string {
        return this.fullName;
    }

    setFullName(fullName: string) {
        this.fullName = fullName;
    }

    getisAgreed(): boolean {
        return this.isAgreed;
    }

    setisAgreed(isAgreed: boolean) {
        this.isAgreed = isAgreed;
    }

    getDate(): string {
        return this.date;
    }

    setDate(date: string) {
        this.date = date;
    }

    getEmploymentHistory() {
        return this.employment_history;
    }

    setEmploymentHistory(data: EmploymentHistory[]) {
        this.employment_history = data;
    }

    getQualifications() {
        return this.qualifications;
    }

    setQualifications(data: Qualifications[]) {
        this.qualifications = data;
    }

    getAcademicQualifications() {
        return this.academicQualifications;
    }

    setAcademicQualifications(data: academicQualifications[]) {
        this.academicQualifications = data;
    }

    getChecklist() {
        return this.checklist;
    }

    setChecklist(data: Checklist[]) {
        this.checklist = data;
    }

    getAttachments() {
        return this.attachments;
    }

    setAttachments(data: Attachements[]) {
        this.attachments = data;
    }



    toString() {
        return JSON.stringify({
            id: this.getId(),
            branch: this.getBranch(),
            finacialServiceDir: this.getFinacialServiceDir(),
            finacialServiceMan: this.getFinacialServiceMan(),
            personal_details: {
                fullNameNric: this.getFullNameNric(),
                preferredName: this.getPreferredName(),
                nricNo: this.getNricNo(),
                dateOfBirth: this.getDateOfBirth(),
                gender: this.getGender(),
                nationality: this.getNationality(),
                placeOfBirth: this.getPlaceOfBirth(),
                finPassportNo: this.getFinPassportNo(),
                Race: this.getRace(),
                maritalStatus: this.getMaritalStatus(),
            },
            spouse_details: {
                spouseNameNric: this.getSpouseNameNric(),
                spouseNricNo: this.getSpouseNricNo(),
                spouseDob: this.getSpouseDob(),
                spouseNationality: this.getSpouseNationality(),
                spouseFinPassportNo: this.getSpouseFinPassportNo(),
                spouseOccupation: this.getSpouseOccuption(),
                nameOfEmployer: this.getSpouseNameoftheemployer(),
            },
            addressfull_details: {
                address: this.getAddress(),
                homeNumber: this.getHomeNumber(),
                mobileNumber: this.getMobileNumber(),
                personalEmailAddress: this.getPersonalEmailAddres(),
            },
            bank_details: {
                bankname: this.getBankname(),
                bankBranchName: this.getBankBranchName(),
                bankAccountNumber: this.getBankAccountNumber(),
            },
            servicefull_details: {
                NotApplicable: this.getServiceStatusNotApplicable(),
                serviceStatus: this.getServiceStatus(),
                enlistmentDate: this.getEnlistmentDate(),
                ordDate: this.getOrdDate(),
            },
            gradefull_details: {
                bscGrade: this.getBscGrade(),
                bscSatisfactory: this.getBscSatisfactory(),
                bscGrade1: this.getBscGrade_1(),
                bscSatisfactory1: this.getBscSatisfactory_1(),
            },
            employment_history: this.getEmploymentHistory(),
            professional_details: {
                m5_res5: this.getm5_res5(),
                m9: this.getm9(),
                m8_rep: this.getm8_rep(),
                bcp: this.getbcp(),
                m6_rep: this.getm6_rep(),
                m9a: this.getm9a(),
                m8a_rep: this.getm8a_rep(),
                pgi: this.getpgi(),
                m6a_rep: this.getm6a_rep(),
                cm_lip: this.getcm_lip(),
                cm_cis: this.getcm_cis(),
                commgi: this.getcommgi(),
                cm_cmp: this.getcm_cmp(),
                hi: this.gethi(),
                cm_lic: this.getcm_lic(),
                cert_in_gi: this.getcert_in_gi(),
            },
            qualifications: this.getAcademicQualifications() || this.getQualifications(),
            checklist: this.getChecklist(),
            attachments: this.getAttachments(),
            declarationcomment_details: {
                declarationComment: this.getComment(),
            },
            declarationfull_details: {
                isAgreed: this.getisAgreed(),
                declarationFullName: this.getFullName(),
                declarationDate: this.getDate(),
            }

        });
    }
}
